// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__34P_I","header":"styles_header__1w0Gh","content":"styles_content__1YGPX","links":"styles_links__1PrRu"};